import { render, staticRenderFns } from "./PermissionItem.vue?vue&type=template&id=3338645e&"
import script from "./PermissionItem.vue?vue&type=script&lang=js&"
export * from "./PermissionItem.vue?vue&type=script&lang=js&"
import style0 from "./PermissionItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCheckbox,VIcon})
